// project.actions.ts
import { createAction, props } from "@ngrx/store";
import { Project } from "../../models/project-field";

// Load actions
const loadProject = createAction("[Project] Load Project");

const loadProjectSuccess = createAction(
  "[Project] Load Project Success",
  props<{ projectList: Project[] }>()
);

const loadProjectFailure = createAction(
  "[Project] Load Project Failure",
  props<{ error: any }>()
);

// Create actions
const createProject = createAction(
  "[Project] Create Project",
  props<{ project: Project }>()
);

const createProjectSuccess = createAction(
  "[Project] Create Project Success",
  props<{ project: Project }>()
);

const createProjectFailure = createAction(
  "[Project] Create Project Failure",
  props<{ error: any }>()
);

// Edit actions
const editProject = createAction(
  "[Project] Edit Project",
  props<{  projectId: Project,project: Project }>()
);

const editProjectSuccess = createAction(
  "[Project] Edit Project Success",
  props<{ project: any }>()
);

// Delete actions
const deleteProject = createAction(
  "[Project] Delete Project",
  props<{ projectId: string }>()
);

const deleteProjectSuccess = createAction(
  "[Project] Delete Project Success",
  props<{ projectId: string }>()
);

export const ProjectActions = {
  loadProject,
  loadProjectSuccess,
  loadProjectFailure,
  createProject,
  createProjectSuccess,
  createProjectFailure,
  editProject,
  editProjectSuccess,
  deleteProject,
  deleteProjectSuccess
};
